import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SharedService {
    selectedVersion: any;
    latestVersion: any;
    selectedHierarchy: any;
    userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    userData$ = this.userDataSubject.asObservable();
    selectedTaxonomy: any;
    taxonomyList: any;
    hierarchyList: any;
    previousSelectedVersion: any;
    getSelectedVersion() {
        return this.selectedVersion;
    }
    setSelectedVersion(version: any) {
        this.selectedVersion = version;
    }
    getLatestVersion() {
        return this.latestVersion;
    }
    setLatestVersion(version: any) {
        this.latestVersion = version;
    }
    getSelectedHierarchy() {
        return this.selectedHierarchy;
    }
    setSelectedHierarchy(hierarchy: any) {
        this.selectedHierarchy = hierarchy;
    }
    getSelectedTaxonomy() {
        return this.selectedTaxonomy;
    }
    setSelectedTaxonomy(taxonomy: any) {
        this.selectedTaxonomy = taxonomy;
    }
    getTaxonomyList() {
        return this.taxonomyList;
    }
    setTaxonomyList(list: any) {
        this.taxonomyList = list;
    }
    getHierarchyList() {
        return this.hierarchyList;
    }
    setHierarchyList(list: any) {
        this.hierarchyList = list;
    }
    getPreviousVersion() {
        return this.previousSelectedVersion;
    }
    setPreviousVersion(version: any) {
        this.previousSelectedVersion = version;
    }
    clearAll() {
        this.selectedVersion = null;
        this.latestVersion = null;
        this.selectedHierarchy = null;
        this.selectedTaxonomy = null;
        this.taxonomyList = [];
        this.hierarchyList = [];
        this.previousSelectedVersion = null;
    }
    previousSelected: boolean = false;
    setOldSelected(value: boolean) {
        this.previousSelected = value;
    }
    getOldSelected() {
        return this.previousSelected;
    }
}
